import { FC, memo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { ROUTING } from '@constants/routing';
import { RootState } from '@store/store';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: FC<AdminRouteProps> = ({ children }) => {
  const isAdmin = useSelector((state: RootState) => state.auth.isAdmin);

  if (!isAdmin) {
    return <Navigate to={ROUTING.ROOT} replace />;
  }

  return <>{children}</>;
};

export default memo(AdminRoute);
